import {Navigate} from "react-router-dom";

import Fourzerofour from "pages/AuthenticationInner/Errors/404Error";
import Fivezerozero from "pages/AuthenticationInner/Errors/500Error";
import Fivezerothree from "pages/AuthenticationInner/Errors/503Error";
import OfflinePage from "pages/AuthenticationInner/Errors/Offline";
import Crm from "pages/Dashboard/Crm";

// Authentication
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import UserProfile from "pages/Authentication/user-profile";

import CategoryList from "../pages/Category/categoryList";
import BrandList from "../pages/Brands/BrandList";
import ColorsList from "../pages/ProductColor/ColorsList";
import AttributesList from "../pages/Attributes/AttributesList";
import ModelList from "../pages/Model/ModelList";
import DiscountList from "../pages/Discount/DiscountList";
import SubMenu from "../pages/SubMenu/SubMenu";

//Product
import Products from "pages/Ecommers/Product/Products";
import ProductGrid from "pages/Ecommers/ProductGrid/ProductGrid";
import ProductDetails from "pages/Ecommers/ProductDetails/ProductDetails";
import CreateProduct from "pages/Ecommers/CreateProduct/CreateProduct";
import Customers from "pages/Ecommers/Customers/Customers";

// Pages
import CreateNews from "../pages/Pages/CreateNews/CreateNews";
import EditNews from "../pages/Pages/EditNews/EditNews";
import DiscountBanner from "../pages/Pages/DiscountBanner/DiscountBanner";
import FooterSettings from "../pages/Pages/Footer/FooterSettings";
import News from "../pages/Pages/News/News";
import ProfileSettings from "../pages/Pages/ProfileSettings/ProfileSettings";
import HomeLayout from "../pages/HomeLayout/HomeLayout";
import Blocks from "../pages/Block/Block";
import Pages from "../pages/Pages/Pages/Pages";
import CreatePage from "../pages/Pages/Pages/CreatePage";
import EditPage from "../pages/Pages/Pages/EditPage";
import CreateBlock from "../pages/Block/CreateBlock";
import EditBlock from "../pages/Block/EditBlock";
import BannerSlider from "../pages/Pages/Banner/BannerSlider";
import MiddleBanner from "../pages/Pages/Banner/MidleBanner";
import RightBanner from "../pages/Pages/Banner/RightBanner";
import Badge from "../pages/badge/Badge";
import UpdatePages from "../pages/Pages/Pages/EditPage";



const authProtectedRoutes = [
    // Dashboard
    {path: "/dashboard", component: <Crm/>},
    {path: "/", exact: true, component: <Navigate to="/dashboard"/>},
    {path: "*", component: <Navigate to="/dashboard"/>},
    {path: "/dashboard", name: "Crm Dashboard", component: <Crm/>},

    //user prpfile
    {path: "/user-profile", name: "UserProfile", component: <UserProfile/>},
    {path: "/", exact: true, name: "Navigate", component: <Navigate to="/dashboard"/>},
    {path: "/category-list", name: "CategoryList", component: <CategoryList/>},
    {path: "/brand-list", name: "BrandList", component: <BrandList/>},
    {path: "/colors-list", name: "ColorsList", component: <ColorsList/>},
    {path: "/attributes-list", name: "Attributes", component: <AttributesList/>},
    {path: "/models-list", name: "Model", component: <ModelList/>},
    {path: "/discounts-list", name: "Discount", component: <DiscountList/>},
    {path: "/sub-menu", name: "Discount", component: <SubMenu/>},

    //Product
    {path: "/products", name: "Products", component: <Products/>},
    {path: "/product-grid", name: "Product Grid", component: <ProductGrid/>},
    {path: "/product-details", name: "Product Details", component: <ProductDetails/>},
    {path: "/create-product", name: "Create Product", component: <CreateProduct/>},
    {path: "/customers", name: "Customers", component: <Customers/>},

     //Pages
    {path: "/banner-slider", name: "BannerSlider", component: <BannerSlider/>},
    {path: "/right-banner", name: "RightBanner", component: <RightBanner/>},
    {path: "/middle-banner", name: "MiddleBanner", component: <MiddleBanner/>},
    {path: "/create-news", name: "CreateNews", component: <CreateNews/>},
    {path: "/edit-news", name: "EditNews", component: <EditNews/>},
    {path: "/discount-banner", name: "DiscountBanner", component: <DiscountBanner/>},
    {path: "/footer-settings", name: "FooterSettings", component: <FooterSettings/>},
    {path: "/news-list", name: "News", component: <News/>},
    {path: "/profile-settings", name: "ProfileSettings", component: <ProfileSettings/>},
    {path: "/home-layout", name: "HomeLayout", component: <HomeLayout/>},
    {path: "/blocks", name: "Block", component: <Blocks/>},
    {path: "/badge", name: "Badge", component: <Badge/>},

    {path: "/pages", name: "Pages", component: <Pages/>},
    {path: "/create-page", name: "CreatePage", component: <CreatePage/>},
    {path: "/update-page", name: "UpdatePage", component: <EditPage/>},

    {path: "/edit-block", name: "EditBlock", component: <EditBlock/>},
    {path: "/create-block", name: "CreateBlock", component: <CreateBlock/>},
];

const publicRoutes = [
    // Authentication
    {path: "/login", name: "Login", component: <Login/>},
    {path: "/logout", name: "Logout", component: <Logout/>},

    // Authentication Inner

    {path: "/auth-404", name: "Fourzerofour", component: <Fourzerofour/>},

    // Error 500
    {path: "/auth-500", name: "Fivezerozero", component: <Fivezerozero/>},

    // Error 503
    {path: "/auth-503", name: "Fivezerothree", component: <Fivezerothree/>},

    // Offline Page
    {path: "/auth-offline", name: "OfflinePage", component: <OfflinePage/>},

];

export {authProtectedRoutes, publicRoutes};